import React from 'react';
import { Helmet } from 'react-helmet-async';
export default function HelmetComponent({ title, description }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name='description' content={`ویو- ${description}`} />
        </Helmet>
    )
}